import config from '@/config';
import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
export const useUpdateAssignedUser = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading, error } = useMutation(values => api.base
        .put(`${config.appUrls.tasks}/api/plannedTasks/UpdateAssignedUser`, {
        taskId: values.taskId,
        userId: values.userId,
        taskLevel: values.taskLevel,
    })
        .then(res => res.data), {
        onSuccess: () => {
            queryClient.invalidateQueries([TaskQueryKey.PlannedTasks]);
        },
        onError: e => {
            handleHttpError(intl)(e);
        },
    });
    return {
        updateAssignedUser: mutateAsync,
        isLoading,
        error,
    };
};
